const GovernanceReportData = () => {

    const data = [
        {
            metric: "Board Diversity",
            question: "What was the management representation by gender (% female / % male) during the last fiscal year?",
            unit: "% female / % male",
            sector: "General",
            year: 2021,
            value: "2%"
        },
        {
            metric: "Board Diversity",
            question: "What was the management representation by gender (% female / % male) during the last fiscal year?",
            unit: "% female / % male",
            sector: "General",
            year: 2021,
            value: "68%"
        },
        {
            metric: "Board Diversity",
            question: "What was the management representation by gender (% female / % male) during the last fiscal year?",
            unit: "% female / % male",
            sector: "General",
            year: 2021,
            value: "740"
        },
        {
            metric: "Board Diversity",
            question: "What was the management representation by gender (% female / % male) during the last fiscal year?",
            unit: "% female / % male",
            sector: "General",
            year: 2021,
            value: "1080"
        },
        {
            metric: "Training & qualification",
            question: "What was the total expenses on training and qualification in relation to revenues during the last fiscal year?",
            unit: "Percentage",
            sector: "General",
            year: 2021,
            value: "40%"
        },
        {
            metric: "Training & qualification",
            question: "What was the hours on training per employee p.a during the last fiscal year?",
            unit: "Hours",
            sector: "General",
            year: 2021,
            value: "48%"
        },
        {
            metric: "Health and safety",
            question: "What was the health rate during the last fiscal year?",
            unit: "Percentage",
            sector: "General",
            year: 2021,
            value: "48%"
        }
    ];


    return (
        <>
            {
                data && Object.keys(data).length > 0 ? (data.map((curData, index) => {
                    const { question, year, metric, unit, sector, value } = curData;

                    return (
                        <tr key={index}>
                            {/* <td>{supplier}</td> */}
                            <td>{year}</td>
                            <td>{metric}</td>
                            <td>{question}</td>
                            <td>{value}</td>
                            {/* <td>{unit}</td>
                            <td>{sector}</td> */}
                        </tr>
                    )
                })
                ) : (
                    <span>No Governance reports data available.</span>
                )
            }
        </>
    )
}

export default GovernanceReportData;